import { TERME_SEC_default } from "./default/TermeSec"
import { TERME_SEC_import_payoffInfo, TERME_SEC_export_payoffInfo } from "src/shared/Cotation/describe/TermeSec"
import { axisConfig } from "./config/AxisConfig"
import { CHART_STYLES } from "./config/ChartStyles"
import { ProdcutType } from "src/type/product"

const styles = CHART_STYLES[ProdcutType.TERME_SEC]

const defaultConfig = axisConfig("Cours à l'échéance", "Cours de couverture") 

const TERME_SEC_import_chart = form => ([
    {
        type: "line",
        key: "cours-a-terme",
        data: [
            {x: form.cours_a_terme*0.9, y: form.cours_a_terme}, 
            {x: form.cours_a_terme*1.1, y: form.cours_a_terme}
        ],
        color: styles.cours_a_terme.color,
        strokeWidth: styles.cours_a_terme.strokeWidth
    },
    {
        type: "line",
        key: "support-1",
        data: [
            {x:  form.cours_a_terme*0.9, y: form.cours_a_terme*0.9 },
            {x: form.cours_a_terme*1.1, y: form.cours_a_terme*1.1 }
        ],
        strokeWidth: 0
    }
])

const TERME_SEC_export_chart = form => ([
    {
        type: "line",
        key: "cours-a-terme",
        data: [
            {x: form.cours_a_terme*0.9, y: form.cours_a_terme}, 
            {x: form.cours_a_terme*1.1, y: form.cours_a_terme}
        ],
        color: styles.cours_a_terme.color,
        strokeWidth: styles.cours_a_terme.strokeWidth
    },
    {
        type: "line",
        key: "support-1",
        data: [
            {x:  form.cours_a_terme*0.9, y: form.cours_a_terme*0.9 },
            {x: form.cours_a_terme*1.1, y: form.cours_a_terme*1.1 }
        ],
        strokeWidth: 0
    }
])

export const TERME_SEC_data = (form) => ([
    {
        option: "1",
        label: "Profil à l'échéance (si import)",
        chart: TERME_SEC_import_chart(form),
        chartDefault: TERME_SEC_import_chart(TERME_SEC_default[0]),
        describe: TERME_SEC_import_payoffInfo(form),
        legends: {
            lines: [
                {title: "Cours à terme", color: styles.cours_a_terme.color, strokeWidth: styles.cours_a_terme.strokeWidth},
            ],
            points: [
            ]
        },
        config: defaultConfig,
        condition: true,
        isAvailable: form.sens === "import" 
    },
    {
        option: "2",
        label: "Profil à l'échéance (si export)",
        chart: TERME_SEC_export_chart(form),
        chartDefault: TERME_SEC_export_chart(TERME_SEC_default[1]),
        describe:TERME_SEC_export_payoffInfo(form),
        legends: {
            lines: [
                {title: "Cours à terme", color: styles.cours_a_terme.color, strokeWidth: styles.cours_a_terme.strokeWidth},
            ],
            points: [
            ]
        },
        config: defaultConfig,
        condition: true,
        isAvailable: form.sens === "export"
    }
])


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/TermeSec.tsx